/**
 * Mobile search (Figma: Navigation_Search). Phone only, on top of Warehouse's SearchBar (theme.js):
 * - Tapping a search icon opens the full-screen search straight away (focus → Warehouse adds .is-fixed)
 * - The X closes the search completely (Warehouse only "unfixes" it back to a bar under the header)
 * - Each typed word is highlighted in product titles (Liquid's highlight only matches the whole phrase)
 */
(function () {
  var phone = window.matchMedia("(max-width: 640px)");

  function wrapper() {
    return document.querySelector(".header__search-bar-wrapper");
  }

  // The visible field. Found by class: after a submit Warehouse moves name="q" onto a hidden copy (see repairForm)
  function field(wrap) {
    return wrap && wrap.querySelector(".search-bar__input");
  }

  // Runs after Warehouse's own click handlers (they listen on the header section, this listens on document)
  document.addEventListener("click", function (event) {
    if (!phone.matches || !event.target.closest) return;
    var wrap = wrapper();
    if (!wrap) return;

    if (event.target.closest('.header [data-action="toggle-search"]')) {
      if (wrap.classList.contains("is-visible")) {
        var input = field(wrap);
        if (input) input.focus(); // still inside the tap, so mobile browsers open the keyboard
      }
      return;
    }

    if (event.target.closest('[data-action="unfix-search"]') && wrap.classList.contains("is-visible")) {
      var q = field(wrap);
      if (q) q.blur();
      var toggle = document.querySelector('.header [data-action="toggle-search"]');
      if (toggle) toggle.click();
    }
  });

  // Show the clear (×) icon while there is text (Warehouse only sets .is-filled on focus)
  document.addEventListener("input", function (event) {
    if (event.target.matches && event.target.matches(".header__search-bar-wrapper .search-bar__input")) {
      event.target.classList.toggle("is-filled", event.target.value !== "");
    }
  });

  function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function highlightTitles(container, query) {
    var words = query.trim().split(/\s+/).filter(function (w) { return w.length > 0; }).map(escapeRegExp);
    if (!words.length) return;
    var pattern = new RegExp("(" + words.join("|") + ")", "gi");

    container.querySelectorAll(".search-bar__item-title").forEach(function (title) {
      if (title.querySelector("strong")) return; // already highlighted by Liquid
      var text = title.textContent;
      var html = "";
      var last = 0;
      text.replace(pattern, function (match, _group, offset) {
        html += escapeHtml(text.slice(last, offset)) + "<strong class=\"highlight\">" + escapeHtml(match) + "</strong>";
        last = offset + match.length;
        return match;
      });
      if (last === 0) return;
      title.innerHTML = html + escapeHtml(text.slice(last));
    });
  }

  function escapeHtml(text) {
    return text.replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function watchResults() {
    var wrap = wrapper();
    var results = wrap && wrap.querySelector(".search-bar__results-inner");
    if (!results || !window.MutationObserver) return;
    // childList only: Warehouse replaces the whole innerHTML; our edits inside titles don't re-trigger this
    new MutationObserver(function () {
      var input = field(wrap);
      if (input) highlightTitles(results, input.value);
    }).observe(results, { childList: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watchResults);
  else watchResults();

  /**
   * Back/forward cache: after a search the phone keeps this page in memory and, on Back, shows it exactly as it
   * was left — search full screen (.is-fixed) and <html class="is-locked">. Warehouse's own pageshow handler only
   * hides the bar (.is-visible), so the overlay flashed and the locked page stopped scrolling/responding until a
   * refresh. Reset the whole open state when the page is hidden (the cached copy is clean) and again on restore.
   */
  /**
   * Warehouse's submit handler removes name="q" from the visible field and adds a hidden copy holding the term.
   * When Back restores the page from the cache, that rewired form stays: typing no longer fires the suggestions
   * (Warehouse listens on [name="q"]), the tap opened the bar instead of the full-screen search, and every submit
   * sent the old hidden term. Put the form back as it was rendered.
   */
  function repairForm(wrap) {
    var input = field(wrap);
    if (!input) return;
    wrap.querySelectorAll('input[type="hidden"][name="q"]').forEach(function (copy) { copy.remove(); });
    if (input.getAttribute("name") !== "q") input.setAttribute("name", "q");
    input.value = "";
  }

  function resetSearchState() {
    var wrap = wrapper();
    if (!wrap) return;
    repairForm(wrap);
    var wasFixed = wrap.classList.contains("is-fixed");
    var input = field(wrap);
    if (input) {
      input.blur();
      input.classList.remove("is-filled");
    }
    wrap.classList.remove("is-fixed", "is-visible");
    var bar = wrap.querySelector(".search-bar");
    if (bar) bar.classList.remove("is-expanded");
    var header = document.querySelector(".header");
    if (header) header.classList.remove("header--search-expanded");
    // The lock is shared with other drawers: only release it when the search set it
    if (wasFixed) document.documentElement.classList.remove("is-locked");
  }

  window.addEventListener("pagehide", function (event) {
    if (event.persisted) resetSearchState();
  });

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    resetSearchState();
    // Safety net: a stale lock with no drawer, menu or search open would leave the page frozen
    var anyOpen = document.querySelector('.header__search-bar-wrapper.is-fixed, #mobile-menu[aria-hidden="false"], #mini-cart[aria-hidden="false"], .drawer[aria-hidden="false"], .modal[aria-hidden="false"]');
    if (!anyOpen) document.documentElement.classList.remove("is-locked");
  });
})();
